export default __webpack_public_path__ + "static/media/JOSA CLASS-9 EXAM PATTERN 2026-27.46a973d5.pdf";